import axios from '../axios'
import Vue from 'vue'

// 尝试登录
export const tryLogin = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/trylogin',
    method: 'get',
    params: data
  })
}
// 登录
export const login = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/tarzan',
    method: 'post',
    data
  })
}
// 自动登录
export const autoLogin = () => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/login',
    method: 'get'
  })
}
// 登出
export const logout = () => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/logout',
    method: 'post'
  })
}

// 获取身份和机构列表
export const getIdentity = () => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/loginrouter',
    method: 'get'
  })
}

// 选择机构和身份
export const selectIdentity = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/login',
    method: 'patch',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/login.js